// extracted by mini-css-extract-plugin
module.exports = {"currentList":"citation-output-bibliography_currentList__SzIVu","viewCitationsEmpty":"citation-output-bibliography_viewCitationsEmpty__Nd_GH"};